<script setup>
import { computed } from 'vue'

import {
  CHANNEL_CATEGORIES_LABEL,
  CHANNEL_SUBCATEGORIES_LABEL,
  CHANNEL_SUBCATEGORY_CLASSIFIERS_LABEL
} from '@/models/channels'

import CTypePermanent from './CTypePermanent.vue'

const props = defineProps({
  channel: {
    type: Object,
    required: true
  },
  disabled: {
    type: Boolean
  }
})

const classifierLabel = computed(() => {
  return CHANNEL_SUBCATEGORY_CLASSIFIERS_LABEL[
    props.channel.subCategoryClassifier
  ]
})

const subCateogryLabel = computed(() => {
  return CHANNEL_SUBCATEGORIES_LABEL[props.channel.subCategory]
})

const categoryLabel = computed(() => {
  return CHANNEL_CATEGORIES_LABEL[props.channel.category]
})

const fixedClassificationLabel = computed(() => {
  return (
    classifierLabel.value || subCateogryLabel.value || categoryLabel.value || ''
  )
})

const createdDate = computed(() => {
  if (typeof props.channel?.createdAt === 'string') {
    return new Date(props.channel.createdAt)
  }
  return props.channel?.createdAt?.toDate()
})
</script>

<template>
  <CTypePermanent :label="fixedClassificationLabel" :date="createdDate" />
</template>
